var map = {
	"./color-golden": [
		67794,
		2121
	],
	"./color-golden.js": [
		67794,
		2121
	],
	"./color-multicolor": [
		29219,
		3478
	],
	"./color-multicolor.js": [
		29219,
		3478
	],
	"./color-palette": [
		91048,
		9799
	],
	"./color-palette.js": [
		91048,
		9799
	],
	"./color-silver": [
		66566,
		8741
	],
	"./color-silver.js": [
		66566,
		8741
	],
	"./color-solid": [
		32992,
		8287
	],
	"./color-solid.js": [
		32992,
		8287
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 24625;
module.exports = webpackAsyncContext;